// @ts-strict-ignore
import { Injectable, ViewContainerRef } from '@angular/core';
import { SohoModalDialogService, SohoModalDialogRef, SohoMessageService } from 'ids-enterprise-ng';
import { Observable } from 'rxjs';
import { LMLoggerService } from '@services/lm-logger.service';
import { LMApplicationMenuAsOfDateDialogComponent } from '@components/applicationmenu/asofdate/lm-application-menu-asofdate-dialog.component';
import { LMDialogButtonKey, LMUniqueIdService } from '@utils/index';

export enum ApplicationMenuAsOfDateDialogStatus {
  RESPONSE_CANCEL = 0,
  RESPONSE_OK
}

export interface ApplicationMenuAsOfDateResult {
  status: ApplicationMenuAsOfDateDialogStatus;
  date: string;
}

@Injectable()
export class LMApplicationMenuAsOfDateDialogService {

  constructor(
    private sohoModalDialogService: SohoModalDialogService,
    private sohoMessageService: SohoMessageService,
    private lmLoggerService: LMLoggerService,
    private lmUniqueIdService: LMUniqueIdService
  ) {}

  /**
   * Prompt Set 'As of Date' dialog
   * @param viewContainerRef
   *
   * @return Observable<any>
   */
  public promptAsOfDateDialog(placeholder: ViewContainerRef, date?: string): Observable<any> {
    const asOfDate: Observable<ApplicationMenuAsOfDateResult> = new Observable<ApplicationMenuAsOfDateResult> (observer => {
      let asOfDateComponent: LMApplicationMenuAsOfDateDialogComponent;
      let dialog: SohoModalDialogRef<any> = undefined;

      const attributes: SohoAttributesArray = [ {
        name: 'data-automation-id',
        value: 'lm-as-of-date-modal'
      } ];

      const sohoModalOptions: SohoModalOptions = {
        fullsize: 'responsive',
        attributes
      };

      const dialogId = 'AsOfDate';
      const buttons = [
        {
          id: this.lmUniqueIdService.uniqueId([ dialogId, LMDialogButtonKey.CANCEL ]),
          text: Soho.Locale.translate(LMDialogButtonKey.CANCEL),
          click: (e, modal) => {
            modal.isCancelled = true;
            dialog.close(<ApplicationMenuAsOfDateResult> {
              status: ApplicationMenuAsOfDateDialogStatus.RESPONSE_CANCEL
            });
          }
        },
        {
          id: this.lmUniqueIdService.uniqueId([ dialogId, LMDialogButtonKey.OK ]),
          text: Soho.Locale.translate(LMDialogButtonKey.OK),
          click: (e, modal) => {
            const currentDate = new Date();
            if (asOfDateComponent.getDate() === currentDate.toLocaleDateString()) {
              const messageDialogId = 'AsOfDateValidationMessage';
              this.sohoMessageService
                .error()
                .message(Soho.Locale.translate(messageDialogId))
                .title('')
                .buttons([
                  {
                    id: this.lmUniqueIdService.uniqueId([ messageDialogId, LMDialogButtonKey.CLOSE ]),
                    text: Soho.Locale.translate(LMDialogButtonKey.CLOSE),
                    click: (evt, errorModal) => {
                      errorModal.close(true);
                    }
                  }
                ])
                .open();
            } else {
              dialog.close(<ApplicationMenuAsOfDateResult> {
                status: ApplicationMenuAsOfDateDialogStatus.RESPONSE_OK,
                date: asOfDateComponent.getDate()
              });
            }
          },
          validate: false,
          isDefault: true
        }
      ];
      dialog = this.sohoModalDialogService
        .modal(LMApplicationMenuAsOfDateDialogComponent, placeholder, sohoModalOptions)
        .buttons(buttons)
        .title(Soho.Locale.translate('AsOfDateLabel'))
        .isAlert(false)
        .open()
        .apply((asOfDateForm: LMApplicationMenuAsOfDateDialogComponent) => {
          asOfDateComponent = asOfDateForm;
          if (asOfDate) {
            asOfDateComponent.asOfDate = date;
          }
        })
        .afterClose(result => {
          observer.next(result);
          observer.complete();
        });
    });
    return asOfDate;
  }
}
